// import colors from 'vuetify/lib/util/colors'
import colors from 'vuetify/util/colors'
import '@mdi/font/css/materialdesignicons.css'
// import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import "vuetify/lib/styles/main.css";
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        dark: false,
        colors: {        
          primary: colors.shades.black,
          secondary: colors.shades.black,
          accent: colors.yellow.darken2,
          error: colors.red.accent4,
          info: colors.grey.darken3,
          success: colors.green.darken1,
          warning: colors.orange.darken1,
          backgroundNormal: colors.blue.lighten5,
          backgroundUnauthorizedExpired: colors.deepOrange.lighten5,
          backgroundUnauthorizedExpired2: colors.red.lighten5,
          backgroundUnauthorizedExpired3: colors.purple.lighten5,
          backgroundEditable: colors.green.lighten4,
          backgroundReadOnly: colors.grey.lighten3,
          activePeoplePicker: colors.shades.white,
          disabledPeoplePicker: colors.grey.lighten2
        }
      },
      dark: {
        dark: false,
        colors: {
          primary: colors.shades.black,
          secondary: colors.shades.black,
          accent: colors.yellow.darken2,
          error: colors.red.accent4,
          info: colors.grey.darken3,
          success: colors.green.darken1,
          warning: colors.orange.darken1,
          backgroundNormal: colors.indigo.darken4,
          backgroundUnauthorizedExpired: colors.orange.darken1,
          backgroundUnauthorizedExpired2: colors.red.darken1,
          backgroundUnauthorizedExpired3: colors.purple.darken1,
          backgroundEditable: colors.green.darken1,
          backgroundReadOnly: colors.grey.darken1
        }
      }
    }
  },
  breakpoint: {
    scrollBarWidth: 24
  },
  components,
  directives
})


export default vuetify
